module.exports = __webpack_public_path__ + "img/1530441520.b40d9d44.jpg";